/**
 * @generated SignedSource<<5bed9343637d058e8ae5971a30f1ed94>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespPersonalizedItemsCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_user">;
  readonly " $fragmentType": "PdpRespPersonalizedItemsCarousel_user";
};
export type PdpRespPersonalizedItemsCarousel_user$key = {
  readonly " $data"?: PdpRespPersonalizedItemsCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPersonalizedItemsCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespPersonalizedItemsCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespProductTileCarousel_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "8c8ba1d54e8e6387b8c9010710542a89";

export default node;
